import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../common/EditPage';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useState } from "react";
import { getOne, create } from './../../common/v4/BackendProvider';
import { useNavigate } from 'react-router-dom';

const ProductCreate = () => {

    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        getOne(`/admin/products/products/`, 'new')
            .then(response => {
                setMetadata(response.data.metadata);
            }).catch(error => {
                toast.error("Error fetching rate profile: " + error.message, {});
            });
    }, []);

    const handleSave = () => {
        create(`/admin/products/products/`, {data: data}).then(response => {
            toast.success("Rate profile created successfully", {});
            navigate('/products/rate_profiles');
        }).catch(error => {
            toast.error("Error creating rate profile: " + error.message, {});
        });
    };


    const handleCancel = () => {
        navigate('/products/rate_profiles');
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Rate Profile">
                <EditPagePanel>
                    <EditPageTextField label="Name" id="ATRPRODUCTNAME" onChange={ onChange } value={ data.ATRPRODUCTNAME } />
                    <EditPageSelect label="Type" id="ATRPRODUCTTYPE" onChange={ onChange } value={ data.ATRPRODUCTTYPE } options={ metadata?.ATRPRODUCTTYPE?.values } />
                    <EditPageTextField label="Description" id="ATRPRODUCTDESCR" onChange={ onChange } value={ data.ATRPRODUCTDESCR } />
                    <EditPageCheckbox label="Active" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default ProductCreate;